<template>
  <div>
    <div class="content-header">
      <h1>Cenníky</h1>
    </div>
    <section class="content">
      <div class="box">
        <div class="box-header">
          <button class="btn btn-success btn-sm" @click.prevent="createShow()"><i class="fa fa-plus"></i> Pridať cenník</button>
          <div class="box-tools">
            <div class="input-group input-group-sm input-search hidden-xs">
              <input type="text" v-model="query" class="form-control pull-right" placeholder="Vyhľadaj podľa zákazníka.">

              <div class="input-group-btn">
                <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
        <price-list-create-modal :show-model="showCreateModal" :model="selectedPriceList" @close="hideModals()"></price-list-create-modal>
        <price-list-detail-modal :show-model="showDetailModal" :model="selectedPriceList" @close="hideModals()"></price-list-detail-modal>

        <div class="box-body">
          <div class="row" v-if="priceLists.length">
            <div class="col-md-12">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>Zákazník</th>
                  <th>Platný od</th>
                  <th>Platný do</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="priceList in priceLists">
                  <tr>
                    <td>{{ priceList.customer.companyName }}</td>
                    <td>{{ priceList.validFrom | date }}</td>
                    <td>{{ priceList.validTo | date }}</td>
                    <td class="text-right text-nowrap">
                      <button class="btn btn-xs btn-link" @click.prevent="showPriceList(priceList)"><i class="fa fa-2x fa-eye text-primary" title="Zobraziť"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="editPriceList(priceList)"><i class="fa fa-2x fa-pencil-square-o text-primary" title="Editovať"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="deletePriceList(priceList)"><i class="fa fa-2x fa-times text-danger" title="Zmazať"></i></button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <loading id="priceLists"></loading>
          <no-records :data="priceLists" loadingId="priceLists"></no-records>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import moment from 'moment';
  import _ from 'lodash';
  import { alert } from 'vue-strap';
  import { mapState } from 'vuex';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';
  import priceListService from 'services/priceListService';
  import priceListCreateModal from 'components/priceListCreateModal';
  import priceListDetailModal from 'components/priceListDetailModal';
  import notificationService from 'services/notificationService';

  export default {
    components: {alert, loading, noRecords, priceListCreateModal, priceListDetailModal},
    data: () => ({
      moment: moment(),
      showCreateModal: false,
      showDetailModal: false,
      selectedPriceList: null,
      query: null
    }),
    computed: mapState({
      priceLists(state) {
        let allPriceLists = state.priceList.items;
        if (this.query) {
          let regexp = new RegExp(normalize(this.query), "g");
          return allPriceLists.filter(priceList => !!normalize(priceList.customer.companyName).match(regexp));
        } else {
          return allPriceLists;
        }
      },
      customers(state) {
          return state.customer.items;
      }
    }),
    methods: {
      createShow () {
        this.selectedPriceList = priceListService.newPriceList();
        this.showCreateModal = true;
      },
      hideModals () {
        this.showCreateModal = false;
        this.showDetailModal = false;
      },
      showPriceList(priceList) {
        this.selectedPriceList = priceList;
        this.showDetailModal = true;
      },
      editPriceList(priceList) {
        this.selectedPriceList = _.cloneDeep(priceList);
        this.showCreateModal = true;
      },
      deletePriceList(priceList) {
        this.confirm('priceList.delete.confirmation', [priceList.customer.companyName]).then(() => {
          this.$store.dispatch('priceList/delete', priceList.id).then((result) => {
            if (result) {
              notificationService.success('Cenník bol zmazaný.');
            }
          }).catch(this.unprotect);
        }).catch(this.unprotect);
      }
    },
    created () {
      this.$store.dispatch('priceList/getAll');
    }
  }
</script>



// WEBPACK FOOTER //
// client/views/priceLists.vue